var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-state"},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":"empty-state-icon","width":_vm.iconWidth}}),(_vm.message)?_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }